import { FC } from 'react';
import clsx from 'clsx';
import { setTableViewScheduleStage } from 'entities/viewStage';
import { useHistoryOfViewStage } from 'shared/hooks';
import { useAppDispatch, useAppSelector } from 'shared/lib';

import styles from './styles.module.scss';

export const TableSwitchSchedule: FC = () => {
  const dispatch = useAppDispatch();
  const { tableViewScheduleStage } = useAppSelector(
    (state) => state.viewStageReducer,
  );
  const { setTableViewScheduleStageHistory } = useHistoryOfViewStage();
  return (
    <div className={styles['buttons-select']}>
      <button
        className={clsx(styles['buttons-select__item'], styles['byDay'], {
          [styles['buttons-select_active']]: tableViewScheduleStage === 'byDay',
        })}
        onClick={() => {
          dispatch(setTableViewScheduleStage('byDay'));
          setTableViewScheduleStageHistory('byDay');
        }}
      >
        По дням
      </button>
      <button
        className={clsx(styles['buttons-select__item'], styles['full'], {
          [styles['buttons-select_active']]: tableViewScheduleStage === 'full',
        })}
        onClick={() => {
          dispatch(setTableViewScheduleStage('full'));
          setTableViewScheduleStageHistory('full');
        }}
      >
        Полностью
      </button>
    </div>
  );
};
